import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import ContentfulRichText from "../../utilities/contentful-rich-text";
import './styles.css';
import useIsMobile from "../../utilities/useIsMobile";

export const InfoBoxes = ({ title, type, frameColor, text }) => {
  const isMobile = useIsMobile();

  const imageHash = {
    "Helpful Articles": (
      <StaticImage
        src="../../images/Open-book-icon.png"
        alt=""
        height={150}
        width={170}
        objectFit="contain"
      />
    ),
    "Fun Fact": (
      <StaticImage
        src="../../images/Magic-wand-icon.png"
        alt=""
        height={150}
        width={170}
        objectFit="contain"
      />
    ),
    "Did You Know?": (
      <StaticImage
        src="../../images/Eyeglasses-icon.png"
        alt=""
        height={150}
        width={170}
        objectFit="contain"
      />
    ),
    "Side Note": (
      <StaticImage
        src="../../images/errow-icon.png"
        alt=""
        height={150}
        width={170}
        objectFit="contain"
      />
    ),
    Definition: (
      <StaticImage
        src="../../images/ABC-blocks-icon.png"
        alt=""
        height={150}
        width={170}
        objectFit="contain"
      />
    ),
  };
  return (
    <div
      className="info-boxes border-2 rounded-lg p-16 bg-white"
      style={{ borderColor: frameColor }}
    >
      {!isMobile && <div className="info-boxes-title text-5xl">{title}</div>}
      <div className="info-boxes-content flex flex-col md:flex-row">
        {isMobile && <div className="info-boxes-title text-5xl order-2">{title}</div>}
        <ContentfulRichText className="md:w-[70%] order-3 md:order-1" raw={text} />
        <span className="flex justify-center md:w-[30%] mb-4 order-1 info-boxes-image">{imageHash[type]}</span>
      </div>
    </div>
  );
};
